customElements.define('component-feedback-widget', class FeedbackWidget extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.props = {
      feedbackApiUrl: this.getAttribute('feedback-api-url'),
      feedbackApiKey: this.getAttribute('feedback-api-key')
    }

    // DOM Elements
    const overlaySelector = 'js-feedback-modal-overlay';
    this.feedbackWidgetSelector = this.querySelector('.component-feedback-widget__container');

    this.overlay = document.querySelector(`.${overlaySelector}`);
    this.modal = document.querySelector('.js-feedback-modal');
    this.closeButton = document.querySelector('.js-feedback-modal-close');
    this.feedbackForm = document.querySelector('form[name=feedback-form]');
    this.submitButton = document.querySelector('.js-submit-btn');
    this.errorMessageSpan = document.querySelector('.js-email-error-span');
    this.feedbackSubject = document.querySelector('.js-feedback-select');
    this.form = document.querySelector('.js-feedback-form');
    this.successMessage = document.querySelector('.js-feedback-success-message');

    // Form Fields
    this.emailInput = document.querySelector('input[name=feedback-email-input]');
    this.emailInputLabel = document.querySelector('.js-email-input-label');
    this.feedbackTextarea = document.querySelector('.js-feedback-textarea');
    this.followUpCheckbox = document.querySelector('input[name=followup-checkbox]');
    this.followUpChecked = this.followUpCheckbox.checked;

    // Events
    this.form.addEventListener('change', () => {
      this.successMessage.classList.add('component-feedback-widget__message--hidden');
      this.submitButton.disabled = !this.form.checkValidity() ||
        (!this.feedbackTextarea.checkValidity() || !this.feedbackSubject.checkValidity() ||
          (this.followUpChecked && !this.emailInput.checkValidity()));
    });
    this.feedbackSubject.addEventListener('change', () => {
      if (this.feedbackSubject.value !== '') {
        this.showErrorMessageSection(false, this.feedbackSubject, '.js-subject-error');
      } else {
        this.showErrorMessageSection(true, this.feedbackSubject, '.js-subject-error');
      }
    });
    this.emailInput.addEventListener('keyup', () => {
      this.validateEmailInput();
    });
    this.feedbackTextarea.addEventListener('keyup', () => {
      this.validateFeedback();
    });
    if (this.feedbackForm) {
      this.feedbackForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitForm();
      });
    }
    this.followUpCheckbox.addEventListener('change', checkbox => {
      this.followUpChecked = checkbox.srcElement.checked;
      if (this.followUpChecked || this.isUnsubscribeFeedback()) {
        this.showRequiredEmailError();
      } else {
        if (this.emailInput.value.trim() === '') {
          this.errorMessageSpan.textContent = 'Please enter a valid email';
          this.showErrorMessageSection(false, this.emailInput, '.js-email-error');
        }
        this.emailInput.required = false;
        this.emailInputLabel.textContent = 'Email (optional)';
      }
    });
    if (this.feedbackWidgetSelector) {
      this.feedbackWidgetSelector.addEventListener('click', () => {
        this.modal.classList.toggle('component-feedback-widget__hidden');
        document.querySelector('body').classList.add('overflow-hidden');
      });
    }
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.closeModal();
      this.resetFields();
    });
    this.overlay.addEventListener('click', (event) => {
      if (event.target.classList.contains(overlaySelector)) {
        this.closeModal();
        this.resetFields();
      }
    });
  }

  resetFields() {
    // Fields reset
    this.emailInput.value = '';
    this.disableSubmitButton(true);
    this.feedbackTextarea.value = ''
    this.feedbackSubject.value = ''
    this.followUpCheckbox.checked = false;
    this.emailInputLabel.textContent = 'Email (optional)';

    // Inline errors style reset
    this.showErrorMessageSection(false, this.feedbackSubject, '.js-subject-error');
    this.showErrorMessageSection(false, this.feedbackTextarea, '.js-feedback-error');
    this.showErrorMessageSection(false, this.emailInput, '.js-email-error');
  }

  closeModal() {
    this.modal.classList.add('component-feedback-widget__hidden');
    this.successMessage.classList.add('component-feedback-widget__message--hidden');
    document.querySelector('body').classList.remove('overflow-hidden');
  }

  async submitForm() {
    const email = this.emailInput.value.trim();
    const feedbackValue = this.feedbackTextarea.value;
    const feedbackSubjectValue = this.feedbackSubject.value;
    const followUpChecked = this.followUpCheckbox.checked;

    // Validations
    if (feedbackSubjectValue.trim() === '') {
      this.showErrorMessageSection(true, this.feedbackSubject, '.js-subject-error');
      return;
    }
    if (this.feedbackTextarea.value.trim() === '') {
      this.showErrorMessageSection(true, this.feedbackTextarea, '.js-feedback-error');
      return;
    }
    if (followUpChecked && (!email || !this.emailInput.checkValidity() || !validateEmail(email))) {
      this.showErrorMessageSection(true, this.emailInput, '.js-email-error');
      return;
    }
    if (this.isUnsubscribeFeedback() && (!email || !this.emailInput.checkValidity() || !validateEmail(email))) {
      this.showErrorMessageSection(true, this.emailInput, '.js-email-error');
      return;
    }

    // Identify user on Klaviyo
    window.klaviyoIdentify && window.klaviyoIdentify(email);

    const conversationPayload = {
      email,
      subject: feedbackSubjectValue,
      feedback: feedbackValue,
      location: window.location.pathname,
      followUp: followUpChecked,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      viewportHeight: window.innerHeight,
      viewportWidth: window.innerWidth,
      language: window.navigator.language,
      customer: window.theme.customer.id,
      cart: window.cartManager.getLocalCart()
    };

    this.submitButton.textContent = 'SENDING FEEDBACK...';
    this.sendFeedback(conversationPayload)
      .then((resp) => {
        if (resp.ok) {
          this.successMessage.classList.remove('component-feedback-widget__message--hidden');
          this.resetFields();
          setTimeout(() => {
            this.closeModal();
          }, 2000);
        }
      })
      .catch((error) => {
        console.error('Fail to send feedback', error);
      })
      .finally(() => {
        this.submitButton.textContent = 'SUBMIT';
      });
  }

  sendFeedback(payload) {
    const body = JSON.stringify(payload);
    return fetch(this.props.feedbackApiUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${this.props.feedbackApiKey}`,
      }
    });
  }

  showErrorMessageSection(display, element, selector) {
    if (display) {
      element.classList.add('component-feedback-widget__error');
      document.querySelector(selector).classList.remove('component-feedback-widget__message--hidden');
    } else {
      element.classList.remove('component-feedback-widget__error');
      document.querySelector(selector).classList.add('component-feedback-widget__message--hidden');
    }
  }

  disableSubmitButton(value) {
    this.submitButton.disabled = value;
  }

  validateFeedback() {
    const text = this.feedbackTextarea.value.trim();
    if (text !== '') {
      this.disableSubmitButton(false);
      this.showErrorMessageSection(false, this.feedbackTextarea, '.js-feedback-error');
    } else {
      this.disableSubmitButton(true);
      this.showErrorMessageSection(true, this.feedbackTextarea, '.js-feedback-error');
    }
    if (this.isUnsubscribeFeedback()) {
      this.showRequiredEmailError();
    }
  }

  validateEmailInput() {
    const email = this.emailInput.value.trim();

    if (validateEmail(email) || (!this.followUpChecked && email === '') || (this.isUnsubscribeFeedback() && email === '')) {
      this.showErrorMessageSection(false, this.emailInput, '.js-email-error');
    } else {
      if (email) {
        this.errorMessageSpan.textContent = 'Please enter a valid email';
      }
      this.showErrorMessageSection(true, this.emailInput, '.js-email-error');
    }
  }

  isUnsubscribeFeedback() {
    return this.feedbackTextarea.value.toLowerCase().includes('unsubscribe');
  }

  showRequiredEmailError() {
    if (this.emailInput.value.trim() === '') {
      this.errorMessageSpan.textContent = 'Please enter your email';
      this.disableSubmitButton(true);
      this.showErrorMessageSection(true, this.emailInput, '.js-email-error');
    }
    this.emailInput.required = true;
    this.emailInputLabel.textContent = 'Email (required)';
  }
});
